import styled from '@emotion/styled';
import { Text } from '@/components/atoms/Text';

export const Container = styled.div`
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};
    margin: ${({ theme }) => theme.spacing[4]};
    div {
        flex: 1 1 30%;
    }
`;

export const FormControls = styled.div`
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.font.family};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[2]};
    margin: ${({ theme }) => theme.spacing[2]};
    div {
        flex: 1 1 30%;
    }
`;

export const FormControl = styled.div`
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.font.family};
    border-radius: ${({ theme }) => theme.radius.main};
    margin: ${({ theme }) => theme.spacing[4]} 0;
    div {
        flex: 1 1 30%;
    }
`;

export const SuccessMessage = styled(Text)`
    margin-top: ${({ theme }) => theme.spacing[1]};
    color: ${({ theme }) => theme.color.green200};
`;

export const ErrorMessage = styled(Text)`
    margin-top: ${({ theme }) => theme.spacing[1]};
    color: ${({ theme }) => theme.color.bloodyMary};
`;

export const LogsContainer = styled.div`
    background-color: ${({ theme }) => theme.color.slate100};
    border: 1px solid ${({ theme }) => theme.color.slate200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[3]};
    margin: ${({ theme }) => theme.spacing[4]} 0;
    max-height: 200px;
    overflow-y: auto;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    line-height: 1.4;
    box-shadow: ${({ theme }) => theme.shadow.inside[100]};
`;

export const LogLine = styled.div<{ isStreaming?: boolean; isSuccess?: boolean }>`
    color: ${({ theme, isSuccess }) => (isSuccess ? theme.color.emerald : theme.color.orange200)};
    margin: 2px 0;
    padding: 2px 4px;
    white-space: pre-wrap;
    word-break: break-word;

    ${({ isStreaming, theme }) =>
        isStreaming &&
        `
        &:last-child {
            position: relative;

            &::after {
                content: '▊';
                color: ${theme.color.orange200};
                animation: blink 1s infinite;
            }
        }

        @keyframes blink {
            0%, 50% { opacity: 1; }
            51%, 100% { opacity: 0; }
        }
    `}
`;
